module.exports = "img/flags/CW.cb93a9a.png";